import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { useTranslation } from 'react-i18next';

export interface TokenTypeFilterStateControllerProps {
  value: GatewayTokenModel['type'];
  onRemove: FilteredItemProps['onRemove'];
}

export const TokenTypeFilterStateController = ({
  value,
  onRemove,
}: TokenTypeFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="electric-car-2"
      label={t(`delmonicos-shared-sdk.enums-token-type.${value}`)}
      onRemove={onRemove}
    />
  );
};
